import React, {FC, useState} from 'react';
import {useTranslation} from 'gatsby-plugin-react-i18next';

import {LiquidPowder} from '../../types/data';
import {extractData} from '../../services/utils';
import {SupportedRegions} from '../../types/lang';
import PageLayout from '../Pages/PageLayout/PageLayout';
import LiquidsPowdersList from '../Caramel/LiquidsPowdersList';
import LiquidsPowdersInfo, {LiquidsPowdersInfoProps} from '../Caramel/LiquidsPowdersInfo';


type Props = {
  allPdf: LiquidsPowdersInfoProps['allPdf'],
  selectedArea: SupportedRegions | null,
  data: ReturnType<typeof extractData>,
  category: number,
  title?: string,
};


const ProductCategory: FC<Props> = ({allPdf, category, data, selectedArea, title}) => {
  const {t} = useTranslation();
  const categoryData = extractData(data, category);
  const [informations, setInformations] = useState<LiquidPowder>();

  return (
    <>
      <PageLayout title={title ?? t(data[`category${category}`].name as any)}/>

      <LiquidsPowdersInfo
        allPdf={allPdf}
        selectedArea={selectedArea}
        informations={informations}
        setInformations={setInformations}
      />

      <LiquidsPowdersList
        data={categoryData}
        selectedArea={selectedArea}
        setInformations={setInformations}
      />
    </>
  );
};


export default ProductCategory;
